import { WNS_STREAM } from '@constants/resources';
import { SECURITY_PRIVILEGES_READ } from '@constants/variables';

export const authorizationObject = {
    [WNS_STREAM]: SECURITY_PRIVILEGES_READ,
};
